import {Component, inject, OnInit} from '@angular/core';
import {Card} from 'primeng/card';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {Button} from 'primeng/button';
import {Router} from '@angular/router';
import {AdicionarDemandaStateService} from '@core/services/adicionar-demanda-state.service';
import {
  DadosLocalizacaoDemandaComponent
} from '@pages/demandas/dados-localizacao-demanda/dados-localizacao-demanda.component';
import {IconPencilComponent} from '@components/icons/icon-pencil/icon-pencil.component';
import {MSG_REQUIRED_FIELDS_FORM} from '@shared/constants/messages';
import {MessageService} from 'primeng/api';
import {DialogComponent} from '@components/dialogs/dialog/dialog.component';
import {FormDescricaoDemandaComponent} from '@pages/demandas/form-descricao-demanda/form-descricao-demanda.component';
import {IconBoldArrowRightComponent} from '@components/icons/icon-bold-arrow-right/icon-bold-arrow-right.component';
import {IconBoldCloseSquareComponent} from '@components/icons/icon-bold-close-square/icon-bold-close-square.component';

@Component({
  selector: 'app-adicionar-demanda-form',
  imports: [
    Card,
    ReactiveFormsModule,
    Button,
    DadosLocalizacaoDemandaComponent,
    IconPencilComponent,
    DialogComponent,
    FormDescricaoDemandaComponent,
    IconBoldArrowRightComponent,
    IconBoldCloseSquareComponent,
  ],
  templateUrl: './adicionar-demanda-form.component.html',
  styleUrl: './adicionar-demanda-form.component.css'
})
export class AdicionarDemandaFormComponent implements OnInit {
  protected form!: FormGroup;
  protected showOrientacoesUsuarioDialog = false;

  private readonly fb = inject(FormBuilder);
  private readonly router = inject(Router);
  private readonly messageService = inject(MessageService);
  protected readonly state = inject(AdicionarDemandaStateService);

  ngOnInit() {
    if (!this.state.orientacoesExibidas()) {
      this.showOrientacoesUsuarioDialog = true;
      this.state.orientacoesExibidas.set(true);
    }
    this.initForm();
  }

  private initForm() {
    const descricao = this.state.descricaoDemanda();
    this.form = this.fb.group({
      tipoRepresentacao: [descricao?.tipoRepresentacao ?? null, Validators.required],
      nomeSolicitante: [descricao?.nomeSolicitante ?? '', Validators.required],
      justificativa: [descricao?.justificativa ?? '', Validators.required],
      existeProcessoSei: [descricao?.existeProcessoSei ?? false],
      numeroProcessoSei: [descricao?.numeroProcessoSei ?? null],
      tipoProcessoSei: [descricao?.tipoProcessoSei ?? null],
      descricaoProcesso: [descricao?.descricaoProcesso ?? null],
      representacaoUsuarioConcessionaria: [descricao?.representacaoUsuarioConcessionaria ?? null]
    });

    if (descricao?.existeProcessoSei) {
      this.form.get('numeroProcessoSei')!.setValidators(Validators.required);
      this.form.get('tipoProcessoSei')!.setValidators(Validators.required);
      this.form.get('numeroProcessoSei')!.updateValueAndValidity();
      this.form.get('tipoProcessoSei')!.updateValueAndValidity();
    }
  }

  protected onSubmit(): void {
    if (this.form.invalid) {
      this.messageService.add({severity: 'warn', summary: 'Atenção!', detail: MSG_REQUIRED_FIELDS_FORM});
      this.form.markAllAsTouched();
      return;
    }
    const formValue = this.form.getRawValue();
    this.state.setDescricao(formValue);
    this.state.irParaStep(2);
    this.router.navigate(['/demandas/adicionar/anexos']);
  }

  onEditLocalizacao(): void {
    this.state.limparLocalizacao();
    this.state.irParaStep(0);
    this.router.navigate(['/demandas/adicionar']);
  }
}
